<% var component = new Anvil.models.components.TinyMCE(field) %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<% if (!('no_label' in field) || field.no_label == false) { %>
	<div class="col-4">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<% } %>
	<div class="col">
		<textarea class="form-control" id="<%= form.name %>_<%= field.name %>" name="<%= field.name %>" rows="3" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %>><%= form.data[field.name] %></textarea>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
